import { server } from 'config/environment'

export class Sound {
  private readonly url: string
  private readonly start: number
  private audio: HTMLAudioElement | null = null

  constructor(url: string, start?: number) {
    this.url = url
    this.start = start ?? 0
  }

  ensure() {
    if (server || this.audio) return
    this.audio = new Audio(this.url)
    this.audio.preload = 'auto'

    // @ts-ignore
    window.audio = this.audio
  }

  play() {
    this.ensure()
    if (!this.audio) return
    this.audio.pause()
    this.audio.currentTime = this.start
    this.audio.play()
  }

  stop() {
    if (!this.audio) return
    this.audio.pause()
    this.audio.currentTime = this.start
  }
}
